/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Dikeshield
 */
export class Dikeshield {
    /**
     *
     * @type {string}
     * @memberof Dikeshield
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Dikeshield
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Dikeshield
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Dikeshield
     */
    apiKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Dikeshield
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Dikeshield
     */
    autoApprove: boolean;
}
